module.exports = __webpack_public_path__ + "static/CF-Goosebump1-bdf98889f358b122cf8bad8204e128fa.png";